export const SwitchboardProductType = {
  DISTRIBUTION_BOARD: 1,
  REAR_PANEL: 2,
  FRAME: 3,
  SUPPORT: 4,
  RAIL: 5,
  SLOTTED_PLATE: 6,
  BLIND_PLATE: 7,
  RESERVED_BLIND_PLATE: 8,
  METER_BOX: 9,
  METER_BOX_PLATE: 10,
  SERVICES: 11,
}

export const SwitchboardProductTypeText = {
  [SwitchboardProductType.DISTRIBUTION_BOARD]: 'Distribution Board',
  [SwitchboardProductType.REAR_PANEL]: 'Rear Panel',
  [SwitchboardProductType.FRAME]: 'Frame',
  [SwitchboardProductType.SUPPORT]: 'Support',
  [SwitchboardProductType.RAIL]: 'Rail',
  [SwitchboardProductType.SLOTTED_PLATE]: 'Slotted Plate',
  [SwitchboardProductType.BLIND_PLATE]: 'Blind Plate',
  [SwitchboardProductType.RESERVED_BLIND_PLATE]: 'Reserved Blind Plate',
  [SwitchboardProductType.METER_BOX]: 'Meter Box',
  [SwitchboardProductType.METER_BOX_PLATE]: 'Meter Box Plate',
  [SwitchboardProductType.SERVICES]: 'Services',
}